interface Props {
  readonly summary: string;
}

/** One-sentence description of the calendar currently configured. */
export const SummaryBox = ({ summary }: Props) => (
  <div className="border rounded p-3 mb-4 bg-light">
    <div className="text-uppercase text-muted small mb-1">Summary</div>
    <div>{summary}</div>
  </div>
);
